<template>
  <div>
    <div class="sub_Navi">
      <ul>
        <li><a @click="goBack" class="back">뒤로</a></li>
        <li>
          <h1>AI {{ $t("brief['brief']") }}</h1>
        </li>
        <li class="linkBox"></li>
      </ul>
    </div>
    <div class="subPage_container" v-if="loadDetail">
      <div>
        <div class="briefing_Txt">
          <div ref="content" v-dompurify-html="processedContent" @click="handleClick"></div>
        </div>
      </div>
    </div>
    
    <div class="subPage_container" v-if="!loadDetail">
      <div class="loading_spinner">
        <div class="loading_circle"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

export default {
  data() {
    return {
      id: this.$route.query.id,
      lang: this.$route.query.lang,
    };
  },
  async mounted() {
    this.setLanguage(this.lang);
    await this.getAibriefTitleList();
    await this.chkId();
    await this.getLangAiBrief(this.id);

    // 사진 확대 모달
    Fancybox.bind('[data-fancybox="gallery"]', {});
  },
  computed: {
    ...mapState("board", ["language", "loadDetail", "aiId", "aiBrief"]),

    processedContent() {
      if (!this.aiBrief || !this.aiBrief.content) return "";

      const timeHtml = `<p class="time">${this.aiBrief.Date || ''} ${this.aiBrief.Time || ''} (UTC)</p>`;

      return this.aiBrief.content.replace(
        /(<div[^>]*class=["']news-wrapper["'][^>]*>[\s\S]*?<\/h1>)/i,
        (match) => `${match}\n${timeHtml}`
      );
    }
  },
  methods: {
    ...mapActions("board", ["getLangAiBrief", "getAibriefTitleList"]),
    ...mapMutations("board", ["setLanguage"]),

    handleClick(e) {
      if (
        e.target.classList.contains("ai-title") ||
        e.target.classList.contains("ai-arrow") ||
        e.target.classList.contains("ai-title-wrapper")
      ) {
        this.toggleAccordion(e);
      }
    },
    
    toggleAccordion(e) {
      let titleWrapper;

      if (
        e.target.classList.contains("ai-title") ||
        e.target.classList.contains("ai-arrow")
      ) {
        titleWrapper = e.target.closest(".ai-title-wrapper");
      } else if (e.target.classList.contains("ai-title-wrapper")) {
        titleWrapper = e.target;
      }

      if (titleWrapper) {
        const article = titleWrapper.nextElementSibling;
        if (article && article.tagName === "ARTICLE") {
          article.classList.toggle("active");

          if (article.classList.contains("active")) {
            article.style.maxHeight = article.scrollHeight + "px";
          } else {
            article.style.maxHeight = 0;
          }
        }

        const arrow = titleWrapper.querySelector(".ai-arrow");
        if (arrow) {
          arrow.classList.toggle("active");
        }
      }
    },
    async chkId() {
      let briefId = Number(this.id);

      if (!this.aiId.includes(briefId)) {
        this.$router.push("/board/ai-brief");
      }

      if (
        this.lang != "korea" &&
        this.lang != "japan" &&
        this.lang != "english" &&
        this.lang != "chinese" &&
        this.lang != "vietnam"
      ) {
        this.$router.push("/board/ai-brief");
      }
    },
    goBack() {
      this.$router.push("/board/ai-brief");
    }
  },
};
</script>

<style>
.news-wrapper {
  display: flex;
  padding-bottom: 10px;
  align-items: center;
  justify-content: space-between;
  column-gap: 6px;
}

.news-wrapper h1 {
  color: var(--Main);
  font-family: "Poppins", sans-serif, "Sawarabi Gothic", sans-serif, "LXGW WenKai TC", cursive;
  font-size: 20px;
  font-weight: 600;
  line-height: 105%; 
}

.news-wrapper .time {
  color: var(--Secondary);
  font-family: "Poppins", sans-serif, "Sawarabi Gothic", sans-serif, "LXGW WenKai TC", cursive;
  font-size: 16px;
  font-weight: 400;
  line-height: 131.25%; 
  }

.subPage_container.ai-loading_wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh !important;
}

#controls {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.ai-news #controls,
.ai-not-news #controls {
  margin-bottom: 0;
}

#play-pause-btn {
  width: 30px;
  height: 30px;
  background-image: url("../../../assets/images/player/play.png");
  background-repeat: no-repeat;
  background-size: contain;
  border: none;
  cursor: pointer;
}

#play-pause-btn.pause {
  background-image: url("../../../assets/images/player/pause.png");
}

#timeline {
  flex: 1;
  height: 5px;
  background-color: #ccc;
  position: relative;
  margin-left: 10px;
  margin-right: 10px;
}

#playhead {
  width: 10px;
  height: 10px;
  background-color: #333;
  border-radius: 50%;
  position: absolute;
  top: -3px;
  left: 0;
  cursor: pointer;
}

#time {
  font-size: 12px;
}

.ai-title-wrapper {
  cursor: pointer;
  display: flex;
  padding: 12px;
  justify-content: center;
  align-items: center;
  column-gap: 12px;
  border-radius: 10px;
  background: var(--Menu-Dark, #222223);
}

.ai-title {
  flex: 1;
  color: var(--Main, #FFF);
  font-family: "Poppins", sans-serif, "Sawarabi Gothic", sans-serif, "LXGW WenKai TC", cursive;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 131.25%; 
}

.ai-article {
  margin-bottom: 8px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 300ms ease-in-out;
}

.ai-article.active {
  max-height: 1000px;
  margin-top: 14px;
  margin-bottom: 17px;
}

.ai-article p {
  line-height: 1.8;
  padding-top: 10px;
}

.ai-article.active p, .ai-article p{
  color: var(--Secondary, #7E8088);
  font-family: "Poppins", sans-serif, "Sawarabi Gothic", sans-serif, "LXGW WenKai TC", cursive;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; 
}

.ai-article p:first-child {
  padding-top: 18px;
  
}

.ai-article p:last-child {
  padding-bottom: 12px;
}

.ai-arrow {
  width: 13px;
  height: 16px;
  background-image: url("@/assets/images/player/arrow.png");
  background-size: cover;
  transition: transform 0.3s ease-in-out;
}

.ai-arrow.active {
  transform: rotate(180deg);
}

.ai-article-img {
  width: 100%;
}
</style>

<style scoped>
.loading_spinner_trade {
  margin: auto;
  text-align: center;
  padding-left: 15px;
}

.loading_circle_trade {
  margin: 50px auto;
  width: 40px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: radial-gradient(farthest-side, var(--primary-color) 94%, #0000) top / 8px 8px no-repeat,
    conic-gradient(#0000 30%, var(--primary-color));
  -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 8px), #000 0);
  animation: load 1.5s linear infinite;
}

.loading_spinner {
  margin: auto;
  text-align: center;
  padding-top: 100px;
}

.loading_circle {
  margin: 0 auto;
  width: 60px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: radial-gradient(farthest-side, var(--primary-color) 94%, #0000) top / 8px 8px no-repeat,
    conic-gradient(#0000 30%, var(--primary-color));
  -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 8px), #000 0);
  animation: load 1.5s linear infinite;
}

@keyframes load {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
